import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzTableComponent, NzTableModule } from 'ng-zorro-antd/table';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NgChartsModule } from 'ng2-charts';
import { GroupsComponent } from './groups/groups.component';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { UsersComponent } from './users/users.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DocumentUploadComponent } from './document-upload/document-upload.component';
import { SignatureAssignmentComponent } from './document-upload/signature-assignment/signature-assignment.component';
import { SignDocumentComponent } from './sign-document/sign-document.component';
import { AuditTrailComponent } from './audit-trail/audit-trail.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { SignatureModalComponent } from './signature-modal/signature-modal.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { StateListComponent } from './state-list/state-list.component';
import { StateFormComponent } from './state-form/state-form.component';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzBackTopModule } from 'ng-zorro-antd/back-top';
import { PayplansComponent } from './payplans/payplans.component';
import { DynamicLogicBuilderComponent } from './dynamic-logic-builder/dynamic-logic-builder.component';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { provideNgxMask } from 'ngx-mask';
import { NgxMaskDirective } from 'ngx-mask';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
// import { OnboardingModule } from './onboarding/onboarding.module';
import { RolePermissionsComponent } from './role-permissions/role-permissions.component';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SumPipe } from './pipes/sum.pipe';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { PayrollComponent } from './payroll/payroll.component';
import { CustomerListComponent } from './customers/customer-list.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ManualOrderComponent } from './manual-order/manual-order.component';
import { DuplicateQueueComponent } from './duplicate-queue/duplicate-queue.component';
import { UnassignedCustomersComponent } from './unassigned-customers/unassigned-customers.component';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { Interceptor } from './interceptor';
import { SalesFlowComponent } from './sales-flow/sales-flow.component';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { GenerateLinkComponent } from './generate-link/generate-link.component';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { CancelledReviewsComponent } from './cancelled-reviews/cancelled-reviews.component';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { MyPayHistoryComponent } from './my-pay-history/my-pay-history.component';
import { PayfileReviewComponent } from './payfile-review/payfile-review.component';
import { RequestAreasComponent } from './request-areas/request-areas.component';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { MarketingLeadsComponent } from './marketing-leads/marketing-leads.component';
import { DistributorsComponent } from './distributors/distributors.component';
import { CompaniesComponent } from './companies/companies.component';
import { ProvidersComponent } from './providers/providers.component';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { DiscrepanciesComponent } from './discrepancies/discrepancies.component';
import { CustomerProfileComponent } from './customers/customer-profile/customer-profile.component';
import { UpdateRepModalComponent } from './update-rep-modal/update-rep-modal.component';
import { PayplanAttributesComponent } from './payplan-attributes/payplan-attributes.component';
import { TrainingComponent } from './training/training.component';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { CSVBoxAngularModule } from "@csvbox/angular";
import { CommonModule } from '@angular/common';
import { ImportsComponent } from './imports/imports.component';
import { TrainingListComponent } from './training-list/training-list.component';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { RecruitingLinkComponent } from './recruiting/recruiting.component';
import { MapComponent } from './map/map.component';
import { PinModalComponent } from './map/pin-modal/pin-modal.component';
import { AreaModalComponent } from './map/area-modal/area-modal.component';
import { NzColorPickerModule } from 'ng-zorro-antd/color-picker';
import { ProcessingFeeQueueComponent } from './processing-fee-queue/processing-fee-queue.component';
import { HoldbacksAdminComponent } from './holdbacks-admin/holdbacks-admin.component';
import { CompanyAdminPayrollComponent } from './company-admin-payroll/company-admin-payroll.component';
import { HoldbackBankComponent } from './holdback-bank/holdback-bank.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { ZiplyWelcomeCallComponent } from './ziply-welcome-call/ziply-welcome-call.component';
import { DocusealBuilderComponent, DocusealFormComponent } from '@docuseal/angular';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { AdjustmentsAdminComponent } from './adjustments-admin/adjustments-admin.component';
import { LeadsListComponent } from './leads/leads-list/leads-list.component';
import { DishFlowComponent } from './sales-flow/dish-flow/dish-flow.component';
import { PreQualComponent } from './sales-flow/dish-flow/pre-qual/pre-qual.component';
import { GeneralInfoComponent } from './sales-flow/dish-flow/general-info/general-info.component';
import { DishQualComponent } from './sales-flow/dish-flow/dish-qual/dish-qual.component';
import { DishPlansComponent } from './sales-flow/dish-flow/dish-plans/dish-plans.component';
import { DishEquipmentComponent } from './sales-flow/dish-flow/dish-equipment/dish-equipment.component';
import { DishInstallComponent } from './sales-flow/dish-flow/dish-install/dish-install.component';
import { ProcessingFeeComponent } from './sales-flow/dish-flow/processing-fee/processing-fee.component';
import { DishPaymentComponent } from './sales-flow/dish-flow/dish-payment/dish-payment.component';
import { UserInactivityReviewComponent } from './user-inactivity-review/user-inactivity-review.component';
import { DishReviewComponent } from './sales-flow/dish-flow/dish-review/dish-review.component';
import { DishConfirmationComponent } from './sales-flow/dish-flow/dish-confirmation/dish-confirmation.component';
import { DishAccountImportComponent } from './dish-account-import/dish-account-import.component';
import { PendingPayComponent } from './pending-pay/pending-pay.component';
import { AvailableLeadsComponent } from './available-leads/available-leads.component';
import { PinsByProviderComponent } from './pins-by-provider/pins-by-provider.component';
import { BackgroundQueueComponent } from './background-queue/background-queue.component';
import { ChatComponent } from './chat/chat.component';
import { SystemMessagesComponent } from './system-messages/system-messages.component';
import { QuizzesComponent } from './quizzes/quizzes.component';
import { QuizTakingComponent } from './quiz-taking/quiz-taking.component';
import { UserSelectionListComponent } from './shared/user-selection-list/user-selection-list.component';
import { ProviderPayplansComponent } from './provider-payplans/provider-payplans.component';
import { UserProviderPlansComponent } from './user-provider-plans/user-provider-plans.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { DispositionControlComponent } from './disposition-control/disposition-control.component';
import { DispositionAdminComponent } from './disposition-admin/disposition-admin.component';
import { PortalsComponent } from './portals/portals.component';
import { StarlinkFlowComponent } from './sales-flow/starlink-flow/starlink-flow.component';
import { StarlinkGeneralComponent } from './sales-flow/starlink-flow/starlink-general/starlink-general.component';
import { StarlinkCatalogComponent } from './sales-flow/starlink-flow/starlink-catalog/starlink-catalog.component';
import { OnboardingManagementComponent } from './onboarding-management/onboarding-management.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MarketingManagementComponent } from './marketing-management/marketing-management.component';
import { MarketingBoardComponent } from './marketing-board/marketing-board.component';
import { CdkObserveContent } from "@angular/cdk/observers";
import { PinManagementComponent } from './pin-management/pin-management.component';
import { StarlinkDocumentsComponent } from './sales-flow/starlink-flow/starlink-documents/starlink-documents.component';
import { StarlinkOrderComponent } from './sales-flow/starlink-flow/starlink-order/starlink-order.component';
import { StarlinkIhsOrderComponent } from './sales-flow/starlink-flow/starlink-ihs-order/starlink-ihs-order.component';
import { CompanyPinsComponent } from './company-pins/company-pins.component';
import { OnboardingActionsManagementComponent } from './onboarding-actions-management/onboarding-actions-management.component';
import { OnboardingBoardComponent } from './onboarding-board/onboarding-board.component';
import { MduListComponent } from './map/mdu-list/mdu-list.component';

registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    SignUpComponent,
    SignInComponent,
    HomeComponent,
    GroupsComponent,
    UsersComponent,
    DocumentUploadComponent,
    SignatureAssignmentComponent,
    StateListComponent,
    StateFormComponent,
    // SignDocumentComponent,
    AuditTrailComponent,
    // SignatureModalComponent
    PayplansComponent,
    DynamicLogicBuilderComponent,
    SignDocumentComponent,
    SignatureModalComponent,
    RolePermissionsComponent,
    SumPipe,
    PayrollComponent,
    CustomerListComponent,
    ManualOrderComponent,
    DuplicateQueueComponent,
    UnassignedCustomersComponent,
    SalesFlowComponent,
    GenerateLinkComponent,
    CancelledReviewsComponent,
    MyPayHistoryComponent,
    PayfileReviewComponent,
    RequestAreasComponent,
    MarketingLeadsComponent,
    DistributorsComponent,
    CompaniesComponent,
    ProvidersComponent,
    DiscrepanciesComponent,
    CustomerProfileComponent,
    UpdateRepModalComponent,
    PayplanAttributesComponent,
    TrainingComponent,
    ImportsComponent,
    TrainingListComponent,
    UserProfileComponent,
    RecruitingLinkComponent,
    MapComponent,
    PinModalComponent,
    AreaModalComponent,
    ProcessingFeeQueueComponent,
    HoldbackBankComponent,
    HoldbacksAdminComponent,
    CompanyAdminPayrollComponent,
    LeaderboardComponent,
    ZiplyWelcomeCallComponent,
    OnboardingComponent,
    AdjustmentsAdminComponent,
    LeadsListComponent,
    DishFlowComponent,
    PreQualComponent,
    GeneralInfoComponent,
    DishQualComponent,
    DishPlansComponent,
    DishEquipmentComponent,
    DishInstallComponent,
    ProcessingFeeComponent,
    DishPaymentComponent,
    UserInactivityReviewComponent,
    DishReviewComponent,
    DishConfirmationComponent,
    DishAccountImportComponent,
    PendingPayComponent,
    AvailableLeadsComponent,
    PinsByProviderComponent,
    BackgroundQueueComponent,
    ChatComponent,
    SystemMessagesComponent,
    QuizzesComponent,
    QuizTakingComponent,
    UserSelectionListComponent,
    ProviderPayplansComponent,
    UserProviderPlansComponent,
    MyAccountComponent,
    DispositionControlComponent,
    DispositionAdminComponent,
    PortalsComponent,
    StarlinkFlowComponent,
    StarlinkGeneralComponent,
    StarlinkCatalogComponent,
    OnboardingManagementComponent,
    MarketingManagementComponent,
    MarketingBoardComponent,
    PinManagementComponent,
    StarlinkDocumentsComponent,
    StarlinkOrderComponent,
    StarlinkIhsOrderComponent,
    CompanyPinsComponent,
    OnboardingActionsManagementComponent,
    OnboardingBoardComponent,
    MduListComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    NzCardModule,
    NzStatisticModule,
    NzTableModule,
    NzDatePickerModule,
    NzGridModule,
    NgChartsModule,
    NzMessageModule,
    NzModalModule,
    NzSelectModule,
    NzWaveModule,
    NzDropDownModule,
    NzInputModule,
    NzTagModule,
    NzButtonModule,
    NzPopconfirmModule,
    NzRadioModule,
    NzSpinModule,
    NgxExtendedPdfViewerModule,
    HttpClientModule,
    NgxDropzoneModule,
    FormsModule,
    LeafletModule,
    NzListModule,
    NzBackTopModule,
    NzSpaceModule,
    NzFormModule,
    NzDividerModule,
    NgxMaskDirective,
    NzDatePickerModule,
    NzTimePickerModule,
    NzSwitchModule,
    ScrollingModule,
    NzCheckboxModule,
    NzTabsModule,
    NzAlertModule,
    NzToolTipModule,
    NzTagModule,
    NzDrawerModule,
    NzCollapseModule,
    NzIconModule,
    NzSkeletonModule,
    NzProgressModule,
    NzUploadModule,
    NzIconModule,
    NzCarouselModule,
    NzInputModule,
    NzStepsModule,
    NzInputNumberModule,
    NzPopoverModule,
    NzBadgeModule,
    CSVBoxAngularModule,
    CommonModule,
    NzAvatarModule,
    NzDescriptionsModule,
    NzImageModule,
    NzColorPickerModule,
    NzCommentModule,
    DocusealBuilderComponent,
    DocusealFormComponent,
    DragDropModule,
    CdkObserveContent
],
  providers: [provideNgxMask(), { provide: NZ_I18N, useValue: en_US }, { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
